"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const fp_1 = require("lodash/fp");
const is_empty_1 = __importDefault(require("../../utils/is-empty"));
const message_defaults_json_1 = __importDefault(require("../../message-defaults.json"));
const messageDefault = message_defaults_json_1.default.email;
// We use WHICS rules for email addresses.
const validationBuilder = (message = messageDefault) => (value) => {
    if (!(0, is_empty_1.default)(value)) {
        const emailParts = (0, fp_1.split)('@', String(value));
        const domainCharRules = /([^\w.-]+)/gi;
        const usernameCharRules = /([^\w!#$%&*+=?^_`{|}~.-]+)/gi;
        if ((0, fp_1.isString)(value) &&
            ((0, fp_1.includes)(' ', value) || // Check that there are no spaces
                emailParts.length !== 2 || // Check that there is only 1 @ symbol
                (0, fp_1.startsWith)('@', value) || // Check that @ is not the first character
                !(0, fp_1.includes)('.', emailParts[1]) || // Confirm there is at least 1 "." in the domain section
                (0, fp_1.startsWith)('.', emailParts[1]) || // and its not the first character
                emailParts[1].lastIndexOf('.') > emailParts[1].length - 3 || // At least 2 characters after the final "."
                (0, fp_1.includes)('_', emailParts[1]) || // Confirm there is no "_" in the domain section
                value.length > 255 ||
                domainCharRules.test(emailParts[1]) || // ensure there are no special chars in domain
                usernameCharRules.test(emailParts[0]) || // ensure there are no special chars in username
                (0, fp_1.includes)('..', emailParts[0]) || // ensure there are no consecutive "." in username
                (0, fp_1.includes)('..', emailParts[1])) // ensure there are no consecutive "." in domain
        ) {
            return message;
        }
    }
    return null;
};
validationBuilder.messageDefault = messageDefault;
exports.default = validationBuilder;
